import { render, staticRenderFns } from "./BeCardAppointmentPlaceholder.vue?vue&type=template&id=3d35e704&scoped=true"
import script from "./BeCardAppointmentPlaceholder.vue?vue&type=script&lang=js"
export * from "./BeCardAppointmentPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./BeCardAppointmentPlaceholder.vue?vue&type=style&index=0&id=3d35e704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d35e704",
  null
  
)

export default component.exports